<template src="./Edit.html"></template>

<script>
// import { showAlert } from "@/utils/helpers";

export default {
    props: {
        itemId: {
            type: Number,
            required: true,
        },
    },

    created() {
        this.$store.dispatch("appointments/getDoctors");
        this.$store
            .dispatch("appointments/getForEdit", this.itemId)
            .then((res) => {
                this.vm = res;
                this.getDoctorAppointments();
            }).catch(() => { });
    },
    computed: {
        doctors() {
      return this.$store.state.appointments.doctors;
    },

    },
    data() {
        return {
            vm: {
                appointmentDate: null,
                doctorId: null,
                phoneNo: null,
                doctorName: null,
                patientName: null,
                fileNo: null,
                remarks: null,
            },

        };
    },
    methods: {
        confirm() {
            let vm ={
                appointmentDate :this.vm.appointmentDate,
                remarks :this.vm.remarks,
            }
            this.$store
                .dispatch("appointments/edit", { id: this.itemId, payload: vm })
                .then(() => {
                    this.back();
                })
                .catch(() => { });
        },
        allowedDates(date) {
            const today = new Date();
            today.setHours(0, 0, 0, 0); // تصفير الوقت
            const selectedDate = new Date(date);

            const day = selectedDate.getDay(); // اليوم من الأسبوع
            const isDayAllowed = this.allowedDays.includes(day); // تحقق من الأيام المسموحة
            const isDateAllowed = selectedDate >= today; // تحقق من التاريخ

            return isDayAllowed && isDateAllowed; // تحقق من الشرطين
        },
        getDoctorAppointments() {
            this.allowedDays = [];
            this.doctors.forEach(element => {
                if (element.value == this.vm.doctorId) {
                    element.appointmentSettings.forEach(e => {

       
                        this.allowedDays.push(e.id)
                    });
                }
            });
        },
        back() {

            this.$emit("back");
        },
    },
};
</script>